import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import {createOrUpdateFile} from './upload.js'
// 
// function rand() {
//   return Math.round(Math.random() * 20) - 10;
// }

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));



// TODO use preserveDrawingBuffer or this?
function takeScreenshot(map) {
  return new Promise(function(resolve, reject) {
    map.once("render", function() {
      
      // can call downloadURI on this
      // resolve(map.getCanvas().toDataURL());
      
      map.getCanvas().toBlob(function(blob) {
        resolve(blob)
      })

      // canvas.toBlob(function(blob){
      //   var image = new Image();
      //   image.src = blob;
      //   var uploadTask = storageRef.child('images/' + "apple").put(blob);
      // }); 

    });
    /* trigger render */
    map.setBearing(map.getBearing());
  })
}


function downloadURI(dataStr, exportName) {
  // var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(exportObj));
  var downloadAnchorNode = document.createElement('a');
  downloadAnchorNode.setAttribute("href",     dataStr);
  downloadAnchorNode.setAttribute("download", exportName);
  document.body.appendChild(downloadAnchorNode); // required for firefox
  downloadAnchorNode.click();
  downloadAnchorNode.remove();
}


export default function SimpleModal({mapRef, open, setOpen}) {
  const classes = useStyles();
  // getModalStyle is not a pure function, we roll the style only on the first render
  const [responseBody, setResponseBody] = React.useState({});
  const [formData, setFormData] = React.useState({ addToCatalogue: true})
  const [loading, setLoading] = React.useState(false)

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const saveMap = React.useCallback(() => {
    // var content = mapRef.current.getCanvas().toDataURL('image/png');
    setLoading(true)
    /* example */
    takeScreenshot(mapRef.current).then(content => {
      // downloadURI(content, 'map.png')

      createOrUpdateFile('save-map', content)
        .then(url => {
          const payload = {
            "MFB-map": {
              // 'creatorName': 'Keir Winesmith',
              'population': '481,728',
              'year': '2036',
              // 'email': 'mfb@winesmith.co',
              'url': url,
              'addToCatalogue': true,
              'debugMode': false,  // if debugMode is true, no image is downloaded or created 
              // 'description': "This map was created as part of the Mapping Future Brisbane project that was developed by Dr. Keir Winesmith during the 2020 Digital Collections Catalyst in Residence program at the State Library of Queensland."
              ...formData,
            }
          }

          fetch('https://master-7rqtwti-vimm4jkbc52og.au.platformsh.site/MFB-save-map.php', {
            method: 'POST',
            body: JSON.stringify(payload),
            // headers: {
            //   'Content-Type': 'application/json'
            // }
          })  // body: updatedRecord
          .then(r => r.json())
          .then(r => {
            setResponseBody(r)
            setLoading(false)
          })
          .catch((e) => {
              console.log(e)
          });

        })




    })

  }, [formData])

  const handleChangeCheck = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.checked });
  };
  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  // update graph data, reverse
  // upload image

  const body = (
    <div style={getModalStyle()} className={classes.paper}>
      <h2 id="simple-modal-title">Save your map</h2>
      <p className="sml">Record your vision for Brisbane in 2036.<br/><br/>If you choose, a copy will be sent to the State Library of Queensland, along with your name and a description, to be added to their collection.</p>
      <TextField name="creatorName" label="Name" required value={formData.creatorName || ''} onChange={handleChange} />
      <br/>
      <p>The State Library will send a copy of this map to your email (<a href="https://www.slq.qld.gov.au/privacy">privacy policy</a>).</p>
      <TextField name="email" label="Email" required type="email" value={formData.email || ''}  onChange={handleChange}/>
      <br/>
      <TextField name="description" label="Description" type="description" value={formData.description || ''}  onChange={handleChange} />
      <br/>
      <FormControlLabel
        control={<Checkbox checked={formData.addToCatalogue} onChange={handleChangeCheck} name="addToCatalogue" />}
        label="Add to the collection?"
      />
      <br/>
      <br/>
      <Button
        variant="contained"
        color="primary"
        onClick={saveMap}
        disabled={loading}
      >
        {loading ? "Loading..." : "Generate Map"}
      </Button>
      <br/>
      {
        responseBody.success && <div>
          {responseBody.message} <a target="_blank" href={responseBody.mapURL}> Download the temporary version here. </a>
        </div>
      }
      
    </div>
  );

  return (
    <div>
      {/*<button onClick={handleOpen} className="saveMap">Save Map!</button>*/}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {body}
      </Modal>
    </div>
  );
}